import React, { useState } from 'react';
import { Search, MapPin } from 'lucide-react';



 const LocationModal = ({
  isOpen, 
  onClose, 
  locations, 
  selectedLocation, 
  setSelectedLocation  
}) => {
  if (!isOpen) 
    return (


    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end z-50">
      <div className="bg-white w-full max-w-md mx-auto rounded-t-3xl p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Select Location</h2>
           <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            ✕
          </button>
        </div>

        <div className="mb-4">
          <div className="bg-gray-50 rounded-lg flex items-center px-4 py-3 mb-4">
            <Search className="text-gray-400" size={20} />
            <input
              type="text"
              placeholder="Search your location..."
              className="flex-1 ml-3 outline-none bg-transparent text-gray-800"
            />
          </div>
        </div>

        <div className="space-y-2">
          {locations.map((location, index) => (
            <button
              key={index}
              onClick={() => {
                setSelectedLocation(location);
                onClose();
              }}
              className={`w-full p-4 rounded-xl border-2 transition-all flex items-center justify-between ${
                selectedLocation === location
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-blue-300'
              }`}
            >
              <div className="flex items-center gap-3">
                <MapPin size={20} className="text-blue-600" />
                <span className="font-medium text-gray-800">{location}</span>
              </div>
              {selectedLocation === location && (
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                  <span className="text-white text-xs">✓</span>
                </div>
              )}
            </button>
          ))}
        </div>

        <button 
          onClick={onClose}
          className="w-full bg-blue-500 text-white py-3 rounded-xl font-semibold mt-6 hover:bg-blue-600 transition-all flex items-center justify-center gap-2"
        >
          <MapPin size={20} />
          Use Current Location
        </button>
      </div>
    </div>
  );

        
};

const locations = [
  'Gurugram, Haryana',
  'New Delhi, Delhi',
  'Noida, Uttar Pradesh',
  'Faridabad, Haryana',
  'Ghaziabad, Uttar Pradesh',
];
    export default LocationModal;